import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { formatCurrency } from '../../../../services/oathAgencyVitalsService';

// Aged Open Liability Component - entire bucket cards are clickable
const AgedOpenLiabilitySection = ({ data, onBucketClick }) => {
  if (!data || data.length === 0) {
    return (
      <div className="p-4 qhd:p-5 4k:p-6 text-center text-gray-500 dark:text-gray-400 text-sm qhd:text-base 4k:text-lg">
        No aged liability data available
      </div>
    );
  }

  // Separate buckets from total
  const buckets = data.filter(row => row.description !== 'Total');
  const totalRow = data.find(row => row.description === 'Total');

  const handleBucketClick = (bucket) => {
    if (onBucketClick) {
      onBucketClick('aged-open-liability', bucket);
    }
  };

  return (
    <div className="p-3 qhd:p-5 4k:p-6">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-2.5 qhd:gap-4 4k:gap-5">
        {buckets.map((bucket) => (
          <div
            key={bucket.description}
            className={`bg-gray-50 dark:bg-gray-700/50 rounded-lg qhd:rounded-xl p-2.5 qhd:p-4 4k:p-5 text-center relative ${
              onBucketClick
                ? 'cursor-pointer hover:bg-primary/5 dark:hover:bg-primary/10 hover:shadow-md hover:border-primary/20 border border-transparent transition-all group'
                : ''
            }`}
            onClick={onBucketClick ? () => handleBucketClick(bucket) : undefined}
            role={onBucketClick ? 'button' : undefined}
            tabIndex={onBucketClick ? 0 : undefined}
            onKeyDown={onBucketClick ? (e) => e.key === 'Enter' && handleBucketClick(bucket) : undefined}
          >
            <p className={`text-[10px] sm:text-xs qhd:text-sm 4k:text-base uppercase tracking-wide ${onBucketClick ? 'text-gray-500 dark:text-gray-400 group-hover:text-primary dark:group-hover:text-primary-light' : 'text-gray-500 dark:text-gray-400'}`}>
              {bucket.description}
            </p>
            <p className="text-lg qhd:text-2xl 4k:text-3xl font-bold text-gray-900 dark:text-white">
              {bucket.quantityDisplay || bucket.quantity}
            </p>
            <p className="text-xs qhd:text-sm 4k:text-base text-gray-500 dark:text-gray-400">
              {bucket.liabilityDisplay || formatCurrency(bucket.liability)}
            </p>
            {onBucketClick && (
              <ChevronRightIcon className="w-4 h-4 qhd:w-5 qhd:h-5 4k:w-6 4k:h-6 text-gray-300 dark:text-gray-600 group-hover:text-primary dark:group-hover:text-primary-light absolute right-2 qhd:right-3 4k:right-4 top-1/2 -translate-y-1/2 group-hover:translate-x-0.5 transition-all" />
            )}
          </div>
        ))}
      </div>
      {totalRow && (
        <div
          className={`mt-2.5 qhd:mt-4 4k:mt-5 pt-2.5 qhd:pt-4 4k:pt-5 border-t border-gray-200 dark:border-gray-700 flex items-center justify-between ${
            onBucketClick
              ? 'cursor-pointer hover:bg-primary/5 dark:hover:bg-primary/10 -mx-4 qhd:-mx-5 4k:-mx-6 px-4 qhd:px-5 4k:px-6 py-2 qhd:py-2.5 4k:py-3 rounded qhd:rounded-lg transition-all group'
              : ''
          }`}
          onClick={onBucketClick ? () => handleBucketClick(totalRow) : undefined}
          role={onBucketClick ? 'button' : undefined}
          tabIndex={onBucketClick ? 0 : undefined}
          onKeyDown={onBucketClick ? (e) => e.key === 'Enter' && handleBucketClick(totalRow) : undefined}
        >
          <span className={`text-sm qhd:text-base 4k:text-lg font-semibold ${onBucketClick ? 'text-gray-900 dark:text-white group-hover:text-primary dark:group-hover:text-primary-light' : 'text-gray-900 dark:text-white'}`}>
            Total Liability
          </span>
          <div className="flex items-center gap-4 qhd:gap-5 4k:gap-6">
            <div className="text-right">
              <p className="text-xs qhd:text-sm 4k:text-base text-gray-500 dark:text-gray-400">Count</p>
              <p className="text-base qhd:text-lg 4k:text-xl font-bold text-gray-900 dark:text-white">
                {totalRow.quantityDisplay || totalRow.quantity}
              </p>
            </div>
            <div className="text-right">
              <p className="text-xs qhd:text-sm 4k:text-base text-gray-500 dark:text-gray-400">Liability</p>
              <p className="text-base qhd:text-lg 4k:text-xl font-bold text-gray-900 dark:text-white">
                {totalRow.liabilityDisplay || formatCurrency(totalRow.liability)}
              </p>
            </div>
            {onBucketClick && (
              <ChevronRightIcon className="w-4 h-4 qhd:w-5 qhd:h-5 4k:w-6 4k:h-6 text-gray-300 dark:text-gray-600 group-hover:text-primary dark:group-hover:text-primary-light group-hover:translate-x-0.5 transition-all" />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AgedOpenLiabilitySection;
